module.exports = __webpack_public_path__ + "img/image00006-min.62e94ba3.jpeg";